<template>
  <div id="contenedor-contrato-insumos-tool-bar">
    <v-toolbar flat color="transparent">
      <v-spacer></v-spacer>
      <custom-button
        v-if="mixValidaScopesActions(1)"
        label="Nuevo"
        iconText="mdi-plus"
        tipo="agregar"
        @click="nuevoFrente">
      </custom-button>
    </v-toolbar>
  </div>
</template>

<script>
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'ContratoFrentesToolBar',
  components: {
    CustomButton,
  },
  data() {
    return {};
  },
  methods: {
    nuevoFrente() {
      this.$emit('nuevoFrente');
    },
  },
};
</script>

<style lang="scss">

</style>
